module.exports = __webpack_public_path__ + "static/2-0376c169be2cbdb28ab2cdfd533b88e6.jpg";